interface Config {
  api: string;
  core: string;
  centrifuge: string;
}

interface Configs {
  [key: string]: Config;
}

const config: Configs = {
  development: {
    api: process.env.CLIENT_API_HOST || "localhost:5000",
    core: `https://core.dev.betsy.systems/public/api`,
    centrifuge: `wss://${"turboplinko.dev.turbogames.work"}/connection/websocket`,
  },
  production: {
    api: `${document.location.host}`,
    core: `${document.location.origin}/public/api`,
    centrifuge: `wss://${document.location.host}/connection/websocket`,
  },
};

const env: string = process.env.NODE_ENV || "";

const envConfig = config[env];

export default envConfig;
